import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";
import { useUserStore } from "~/stores/userstore";

export default defineNuxtRouteMiddleware((_unused_to, _unused_from) => {
  console.debug("userHasCompany middleware");
  const userStore = useUserStore();

  if (!userStore.isRegistrationComplete) {
    console.warn(`User registration is not complete.`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Registration not complete`,
      body: `PLease complete your user and company registration first.`,
      appendToast: false,
      position: "top-center",
      variant: "info",
      solid: true,
    } as ToastItem);
    return navigateTo("/users/" + userStore.authUserUuid + "/profile");
  }
});
